import React, { useEffect, useState } from 'react';
import { HiOutlineArrowDown, HiOutlineArrowUp } from 'react-icons/hi';
import Pagination from 'react-pagination-js';

function Table({
  className = '',
  data = [],
  theme = 'table',
  ListHtml = (e) => { },
  rowClass = '',
  columns = [],
  topHead = [],
  count = 50,
  total = 0,
  page = 1,
  result = (e) => { },
  nodata = 'Data Not Found',
  firstColumnClass = '',
  filters,
}) {
  const [pageSize, setPageSize] = useState(count);
  useEffect(() => {
    setPageSize(count);
  }, [count]);
  const handlePageSizeChange = (e) => {
    setPageSize(parseInt(e.target.value));
    result({ event: 'count', value: parseInt(e.target.value) });
  };

  const handlePaginate = (e) => {
    result({ event: 'page', value: e });
  };

  const view = (row) => {
    result({ event: 'row', row });
  };

  const headclick = (itm) => {
    if (itm.sort) {
      result({ event: 'sort', value: itm.key });
    }
  };
  // const generateOptions = () => {
  //   const options = new Set();

  //   options.add(count); // always include the default/initial page size

  //   for (let i = 10; i <= total; i += 10) {
  //     options.add(i);
  //   }

  //   // Always include total as the last "show all" option
  //   options.add(total);

  //   return Array.from(options).sort((a, b) => a - b);
  // };

  const generateOptions = () => {
  const options = new Set();

  // Only add count if it is valid for current total
  if (count <= total) {
    options.add(count);
  }

  for (let i = 10; i <= total; i += 10) {
    options.add(i);
  }

  // Add total only if it is not already present
  if (total > 0) {
    options.add(total);
  }

  return Array.from(options).sort((a, b) => a - b);
};

const effectivePageSize = total > 0
  ? Math.min(pageSize, total)
  : pageSize;
  
  return (
    <div className={`${className}`}>
      {total && data?.length ? (
        <>
          {/* Table view */}
          {theme === 'table' && (
            <div className="table-design relative table-responsive overflow-x-auto">
              <table className="table w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="">
                  {/* Top header */}
                  {topHead?.length ? (
                    <tr className="">
                      {topHead.map((itm, i) => (
                        <th
                          scope="col"
                          className={`bg-[#CC9900] text-white px-2 py-3 text-center ${topHead.length - 1 === i
                            ? ''
                            : ' whitespace-nowrap'
                            }`}
                          colSpan={itm?.colSpan || 0}
                          key={i}
                        >
                          {itm.name}
                        </th>
                      ))}
                    </tr>
                  ) : null}
                  {/* Main header */}
                  <tr>
                    {columns.map((itm) => (
                      <th
                        scope="col"
                        className={`bg-[#CC9900] text-white px-2 py-3${itm.sort ? 'cursor-pointer whitespace-nowrap' : ''
                          }`}
                        key={itm.key}
                      >
                        <span className="inline-flex items-center gap-1 whitespace-nowrap">
                          <span>
                            {' '}
                            {itm.name}
                            {' '}
                          </span>
                          {itm.sort ? (
                            <span className="" onClick={() => headclick(itm)}>
                              {filters.key == itm?.key && filters?.sorder == 'desc' ? <><HiOutlineArrowUp className=" inline text-sm" /> </> : <HiOutlineArrowDown className=" inline text-sm" />}
                            </span>
                          ) : null}
                        </span>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {/* Table data */}
                  {data.map((itm) => (
                    <tr
                      onClick={() => view(itm)}
                      className=""
                      key={itm.id}
                    >
                      {columns.map((citm, index) => (
                        <td className={`px-2 py-4 whitespace-nowrap ${citm.className} ${index === 0 ? firstColumnClass : ''}`} key={citm.key}>
                          {citm.render(itm) || '--'}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* List view */}
          {theme === 'list' && (
            <div className={`rowClass ${rowClass}`}>
              {data.map((itm, index) => (
                <ListHtml key={index} row={itm} />
              ))}
            </div>
          )}

          {/* Pagination */}
          {/* {count < total && ( */}
          {total > 0 && (
            <div className="paginationWrapper flex items-center justify-between mt-15 px-4">
              <p className="w-96 text-sm text-gray-500">
                Show
                {' '}
                <select
                  // value={pageSize}
                  value={effectivePageSize}
                  onChange={handlePageSizeChange}
                  className="border rounded-md px-2 py-1"
                >
                  {/* Dynamically generated options */}
                  {generateOptions().map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                {' '}
                from
                {' '}
                {total}
                {' '}
                data
              </p>
              <Pagination
                currentPage={page}
                totalSize={total}
                // sizePerPage={pageSize}
                sizePerPage={effectivePageSize}
                changeCurrentPage={handlePaginate}
              />
            </div>
          )}
        </>
      ) : (
        // <div className="p-4 text-center">{nodata}</div>
        <div className="mb-3">
          <div className="table-design relative table-responsive overflow-x-auto">
            <table className="table w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="">
                {/* Top header */}
                {topHead?.length ? (
                  <tr className="">
                    {topHead.map((itm, i) => (
                      <th
                        scope="col"
                        className={`bg-[#CC9900] text-white px-2 py-3 text-center ${topHead.length - 1 === i
                          ? ''
                          : 'whitespace-nowrap'
                          }`}
                        colSpan={itm?.colSpan || 0}
                        key={i}
                      >
                        {itm.name}
                      </th>
                    ))}
                  </tr>
                ) : null}
                {/* Main header */}
                <tr>
                  {columns.map((itm) => (
                    <th
                      scope="col"
                      className={`bg-[#CC9900] text-white px-2 py-3${itm.sort ? 'cursor-pointer whitespace-nowrap' : ''
                        }`}
                      onClick={() => headclick(itm)}
                      key={itm.key}
                    >
                      <span className="inline-flex items-center gap-1 whitespace-nowrap">
                        <span>
                          {' '}
                          {itm.name}
                          {' '}
                        </span>
                        {itm.sort ? (
                          <span className="">
                            {filters.key == itm?.key && filters?.sorder == 'desc' ? <><HiOutlineArrowUp className=" inline text-sm" />  hii</> : <HiOutlineArrowDown className=" inline text-sm" />}
                          </span>
                        ) : null}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan="8">
                    <div className="p-4 text-center">{nodata}</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default Table;
